<template>
  <section class="nf">
    <p class="eyebrow">Page not found</p>
    <h1>404</h1>
    <p style="color: var(--muted); max-width: 40ch">
      The space you're looking for doesn't exist, but yours is still waiting to be crafted.
    </p>
    <router-link to="/" class="btn btn-primary" style="margin-top: 1rem">Back home</router-link>
  </section>
</template>

<script>
export default { name: "NotFound" };
</script>
